docReady(initAllScripts);

function docReady(fn: VoidFunction) {
  if (document.readyState !== 'loading') {
    setTimeout(fn, 0);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

//? Helpers
function isPresent(selector: string) {
  return !!document.querySelector(selector);
}

function initIf(selector: string, initFunction: CallableFunction, args: Array<any> = []) {
  if (isPresent(selector)) initFunction(...args);
}

// ? Init all functions
function initAllScripts() {
  initIf('a', scrollToAnimation, [120]);
}

function scrollToAnimation(offset: number) {
  const samePageLinks = document.querySelectorAll('[data-contents] a') as NodeListOf<HTMLAnchorElement>;

  samePageLinks.forEach((anchor) => {
    const scrollTarget = document.querySelector(anchor.getAttribute('href')) as HTMLHeadingElement;
    const elDistanceToTop = window.pageYOffset + scrollTarget.getBoundingClientRect().top;

    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      window.scrollTo({
        top: elDistanceToTop - offset,
        behavior: 'smooth',
      });
    });
  });
}
